import { createStyles, makeStyles } from '@material-ui/core';

export const stylesBase = () =>
createStyles({
  versionContainer: {
    position: 'relative',
  },
  versionTextContainer: {
    position: 'absolute',
    top: '5px',
    left: '3px',
  },
  versionText: {
    fontSize: '13px',
  },
});

export const useStyles = makeStyles(theme => ({
  ...stylesBase(),
}));
